import { render, staticRenderFns } from "./StudentSubject.vue?vue&type=template&id=9a4fa302&"
import script from "./StudentSubject.vue?vue&type=script&lang=js&"
export * from "./StudentSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports